import sqftConfig from "../../../../store/sqftConfig";
import workspace from "../../../workspace";

export default class  ModelCorePoint {
  _x;
  _y;
  _parent;
  _mixins = {
    movable: null
  };

  constructor(x, y, parent, mixins) {
    this._x = x;
    this._y = y;
    this._parent = parent;
    this._mixins = mixins;
  }

  get x() {
    return this.getPosX();
  }

  set x(value) {
    this.setPosX(value);
  }

  get y() {
    return this.getPosY();
  }

  set y(value) {
    this.setPosY(value);
  }

  getPosX() {
    return this.mixins.movable ? this.mixins.movable.posX : this._x;
  }

  getPosY() {
    return this.mixins.movable ? this.mixins.movable.posY : this._y;
  }

  setPosX(value) {
    return this.mixins.movable ? this.mixins.movable.posX = value : this._x = value;
  }

  setPosY(value) {
    return this.mixins.movable ? this.mixins.movable.posY  = value : this._y = value;
  }

  get parent() {
    return this._parent;
  }

  set parent(value) {
    this._parent = value;
  }

  get mixins() {
    return this._mixins;
  }

  set mixins(value) {
    this._mixins = value;
  }

  rotate = (origin, angle, isSlabMode) => {
    let ret = {x: 0, y: 0};
    let tr = {x: this.getPosX() - origin.x, y: this.getPosY() - origin.y};

    ret.x = tr.x * Math.cos(angle) - tr.y * Math.sin(angle);
    ret.y = tr.x * Math.sin(angle) + tr.y * Math.cos(angle);

    //console.log("isSlabMode in point rotation", isSlabMode)
    if (isSlabMode) {
      //todo rotation in slab mode
      this.setPosX(Math.round10(ret.x, -5) + Math.round10(origin.x, -1));
      this.setPosY(Math.round10(ret.y, -5) + Math.round10(origin.y, -1));
    } else {
      this.setPosX(Math.round10(ret.x, -5) + Math.round10(origin.x, -1));
      this.setPosY(Math.round10(ret.y, -5) + Math.round10(origin.y, -1));
    }
  };

  getPointField = () => {
    let fieldWidth = sqftConfig.fieldWidth,
      center = fieldWidth / 2,
      scale = workspace.getScale(),
      offset = parent.getOffset();

    return {
      x: (this.x * scale) - center + offset.x,
      y: (this.y * scale) - center + offset.y,
      width: fieldWidth
    };
  };

  getPointCords = () => {
    let pointField = this.getPointField();

    return {
      x: pointField.x + pointField.width / 2,
      y: pointField.y + pointField.width / 2
    }
  };
}
